export const SAGA_GET_POST_CODE = 'SAGA_GET_POST_CODE';
export default SAGA_GET_POST_CODE;
